export const reportsShowRoutePaths = [
    "/reports/show/:reportname/:reportId",
    "/reports/show/:reportname",
];
